import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Switch } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { BlockContainer } from './blockContainer';

export const ChartBlockContainer = memo(
  ({ children, selectedPeriodTypeKey, onChangePeriodTypeKey, ...rest }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();

    const switchData = useMemo(
      () => [
        {
          key: 'last24Hours',
          value: dictionary.last24Hours,
        },
        {
          key: 'last7Days',
          value: dictionary.last7Days,
        },
        {
          key: 'lastMonth',
          value: dictionary.lastMonth,
        },
        {
          key: null,
          value: dictionary.totalOf,
        },
      ],
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    );

    const selectedItem = switchData.find(
      ({ key }) => key === selectedPeriodTypeKey
    );

    return (
      <BlockContainer {...rest}>
        <View style={styles.headerContainer}>
          <Switch
          activeThumbColor="white"
          thumbColor="white"
            data={switchData}
            selected={selectedItem}
            onChange={(item, index) => onChangePeriodTypeKey(item.key)}
          />
        </View>
        {children}
      </BlockContainer>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flex: 1,
  },
  headerContainer: {
    alignSelf: 'flex-end',
    width: 500,
    paddingHorizontal: 40,
  },
}));
